module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "about-the-author"
    }
  }, [_c('h1', [_vm._v("About the Author")]), _vm._v(" "), _c('p', [_vm._v("Daniel Brande is a prolific writer, consummate marketing practitioner, and eminent award-winning journalist with over 30 years of experience. Blending journalism with marketing, Daniel creates distinctive media products. At the Ghana Broadcasting Corporation and United Nations where he worked for over three decades, his media productions stood out. As a Reuters Fellow at the University of Oxford, Daniel has been a driving force in the media space, freelancing for several international radio stations and magazines with impactful, inventive works. Conveyed in succinct, vivid, lucid language, Daniel’s writings and radio productions make an impression on society.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4f37d542","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/ch001.vue
// module id = 63
// module chunks = 0